import * as React from 'react'
import { AddChip } from '@/components/ui/add-chip'
import { DatePicker, TimePicker } from '@/components/ui/date-time-picker'
import { Label } from '@/components/ui/label'

export function EventScheduleFields({
  startsAt,
  endsAt,
  onStartChange,
  onEndChange,
}: {
  startsAt: string
  endsAt: string
  onStartChange: (value: string) => void
  onEndChange: (value: string) => void
}) {
  const startDate = startsAt.split('T')[0]
  const startTime = startsAt.split('T')[1] ?? '00:00'
  const endDate = endsAt.split('T')[0]
  const endTime = endsAt.split('T')[1] ?? ''
  const [editingEndDate, setEditingEndDate] = React.useState(
    Boolean(endDate && endDate !== startDate),
  )

  React.useEffect(() => {
    if (endDate && endDate !== startDate) setEditingEndDate(true)
  }, [endDate, startDate])

  return (
    <div className="grid gap-2 px-4 py-3 sm:grid-cols-[148px_minmax(0,1fr)] sm:items-start">
      <Label className="pt-1.5 text-caption text-muted-foreground">Date & time</Label>
      <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-4">
        <ScheduleField label="Start date">
          <DatePicker
            id="event-start"
            label="Start date"
            value={startDate}
            onChange={(value) => onStartChange(value ? `${value}T${startTime}` : '')}
          />
        </ScheduleField>
        <ScheduleField label="Start time">
          <TimePicker
            id="event-start-time"
            label="Start time"
            value={startTime}
            disabled={!startDate}
            onChange={(value) => onStartChange(`${startDate}T${value}`)}
          />
        </ScheduleField>
        <ScheduleField label="End time">
          <TimePicker
            id="event-end-time"
            label="End time"
            value={endTime}
            disabled={!startDate}
            onChange={(value) => {
              const date = endDate || startDate
              if (date) onEndChange(`${date}T${value}`)
            }}
            onClear={() => onEndChange('')}
          />
        </ScheduleField>
        {editingEndDate ? (
          <ScheduleField label="End date">
            <DatePicker
              id="event-end"
              label="End date"
              value={endDate}
              onChange={(value) => {
                if (!value) {
                  setEditingEndDate(false)
                  onEndChange('')
                  return
                }

                onEndChange(`${value}T${endTime || startTime}`)
              }}
            />
          </ScheduleField>
        ) : (
          <div className="flex items-end">
            <AddChip onClick={() => setEditingEndDate(true)}>End date</AddChip>
          </div>
        )}
      </div>
    </div>
  )
}

function ScheduleField({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div>
      <Label className="mb-1 block text-caption text-muted-foreground">{label}</Label>
      {children}
    </div>
  )
}
